import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import MinimalTextEditor from "../../../CMS/editor/components/MinimalTextEditor.vue";
import TextEditor from "../../../CMS/editor/components/TextEditor.vue";
import { FormRenderer } from "../../../modules/FML";
import { computed } from "vue";
import { addFMLToken, combineContent, parseContent, removeFMLToken } from "../../../modules/messages";


export default /*#__PURE__*/_defineComponent({
  __name: 'FMLPopupContentEditor',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
	(e: "input", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	value: string;
}





const parsedContent = computed(() => {
  return parseContent(props.value)
})

const textContent = computed({
  get() {
    return parsedContent.value.content
  },
  set(value: string) {
    emit("input", combineContent(value, parsedContent.value.fmlToken));
  }
})

const fmlContent = computed({
  get() {
    return removeFMLToken(parsedContent.value.fmlToken) || ''
  },
  set(v) {
    emit("input", combineContent(parsedContent.value.content, v ? addFMLToken(v) : v))
  }
})

return { __sfc: true,props, emit, parsedContent, textContent, fmlContent, MinimalTextEditor, TextEditor }
}

})